import { createContext, useContext } from 'react'

export interface FormulaSlots {
  list: HTMLElement | null
  notice?: HTMLElement | null
}

export const FormulaSlotContext = createContext<FormulaSlots>({ list: null })

export const useFormulaSlots = (): FormulaSlots => useContext(FormulaSlotContext)
